"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.notRecommendedSafeWrapApiCall = void 0;
const errors_1 = require("./errors");
/**
 * @deprecated - This utility is only used to ease the migration from httpClient
 * to httpClient2 and should not be added to new usages of httpClient2. Instead
 * your function should not try to catch errors at all and error handling should
 * happen outside e.g. by `useQuery()`.
 *
 * This utility method lets us migrate over to httpClient2 more easily. The main
 * difference in the public API of the two clients is that httpClient wraps
 * responses in an IWrappedResult which includes the result, error and a success
 * flag. httpClient2 on the other hand will return the response directly or
 * throw an error.
 *
 * This adaptor will wrap a call to httpClient2 and mimick the httpClient
 * behaviour of catching errors and returning an IWrappedResult.
 *
 * @example
 * ```ts
 * const { result, error, success } = await notRecommendedSafeWrapApiCall(() => {
 *   return httpClient2.get({ path: "/api/user" }).json<User>();
 * });
 * ```
 */
const notRecommendedSafeWrapApiCall = (fn) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const result = yield fn();
        return {
            success: true,
            result,
            error: null,
            // We don't actually know it's a 200 as we don't have access to the
            // response instance but we only ever use this field to check for
            // error status codes so it's not going to break anything if we just
            // convert all 2xx status codes to 200.
            statusCode: 200,
        };
    }
    catch (e) {
        let error = null;
        let statusCode = null;
        if (e instanceof errors_1.HttpError) {
            const text = e.trimmedResponseText;
            if (text.length) {
                error = text;
            }
            statusCode = e.statusCode;
        }
        return { success: false, result: null, error, statusCode };
    }
});
exports.notRecommendedSafeWrapApiCall = notRecommendedSafeWrapApiCall;
//# sourceMappingURL=notRecommendedSafeWrapApiCall.js.map